import { createRoot } from "react-dom/client";

import "bootstrap/dist/css/bootstrap.css";
import "./styles/bootstrap-theme.css";
import "react-toastify/dist/ReactToastify.css";
import "./styles/styles.css";
import "./styles/react-toastify.css";
import "react-widgets/styles.css";

import App from "./App";
import { MsalProvider } from "@azure/msal-react";
import { msalReady } from "./auth/msal";

// dayjs setup
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import customParseFormat from "dayjs/plugin/customParseFormat";
import duration from "dayjs/plugin/duration";

dayjs.extend(utc);
dayjs.extend(customParseFormat);
dayjs.extend(duration);
//----

(async () => {
    const app = msalReady ? (
        <MsalProvider instance={await msalReady}>
            <App />
        </MsalProvider>
    ) : (
        <App />
    );

    createRoot(document.getElementById("root")!).render(app);
})();
